import styles from "./UserTimeTracking.module.css";
import Helmet from "react-helmet";
import Footer from "../../components/Footer";
import TimeTracking from "./components/TimeTracking";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../../components/Loader";

function UserTimeTracking() {

  return (<>
    <Helmet title="User Time Tracking" />

    <div className={`${styles.mainCard}`}>
      <div className={`${styles.CenterBlockSec}`}>
        <TimeTracking />
      </div>
    </div>

    <Footer />
  </>);
}

export default withAuthenticationRequired(UserTimeTracking, {
  onRedirecting: () => <Loader />,
});